// extracted by mini-css-extract-plugin
export default {"questionText":"bw_dc","info":"bw_dd","question":"bw_df"};